import { connect } from 'react-redux'

import BondsPane from '../components/BondsPane'
import { RootState } from '../types/'
import {
  buyBondAction,
  changeBondBuyModeAction,
  clearSelectBond,
  setBondAmount,
  showBondDetailDialog,
} from '../actions/bondActions'
import { TradingAction } from '../actions'
import { BondActions } from '../actions/bondActions'
import { Action, Dispatch } from 'redux'
import { MT4Connector, BondBuyMode } from '@bdswiss/mt4-connector'

const mt4 = MT4Connector.Instance

const image = require('../images/spinner.gif').default

export function mapStateToProps(rootState: RootState) {
  const state = rootState.appState
  return {
    accountLoaded: state.accountLoaded,
    assetLoaded: state.assetLoaded,
    account: mt4.account, // rootState.tradingAccount,
    locale: rootState.appConfig.locale
      ? rootState.appConfig.locale
      : rootState.tradingAccounts.viewer.locale,
    loadingImage: image,
    paneBondsValues: rootState.bondsTradingPane,
    selectedBond: rootState.bondListState.selectedBond,
    demo: rootState.appConfig.demo,
    mode: rootState.appConfig.mode,
  }
}

export function mapDispatchToProps(dispatch: Dispatch<TradingAction | BondActions | Action>) {
  return {
    onSetBondAmount: (amount: number) => dispatch(setBondAmount(amount)),
    buyBond: (mt4Symbol: string, volume: number) => dispatch(buyBondAction(mt4Symbol, volume)),
    clearSelectBond: () => dispatch(clearSelectBond()),
    onChangeBondByMode: (buyMode: BondBuyMode) => dispatch(changeBondBuyModeAction(buyMode)),
    showBondDetailDialog: () => dispatch(showBondDetailDialog()),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BondsPane)
